import { useState } from 'react';
import { BookOpen } from 'lucide-react';
import { BASE } from '../services/api.js';

/** La primera página completa, sin recorte ni ampliación por encima de los 300 px. */
export function PortadaEstudio({ url, marco = true }: { readonly url: string | null | undefined; readonly marco?: boolean }) {
  const [fallida, setFallida] = useState<string | null>(null);
  const ruta = url?.startsWith('/api/') === true ? url : url?.startsWith('/corpus/') === true ? `${BASE}${url}` : null;
  return (
    <div
      className={`flex min-h-[160px] w-full max-w-[300px] items-center justify-center ${marco ? 'rounded-lg border border-(--line) bg-(--paper) p-3' : 'overflow-hidden rounded-md bg-(--paper)'}`}
    >
      {ruta === null || fallida === ruta ? (
        <BookOpen aria-hidden='true' size={36} strokeWidth={1.3} className='text-(--ink-faint)' />
      ) : (
        <img
          src={ruta}
          alt=''
          loading='lazy'
          decoding='async'
          className='block h-auto w-full max-w-[300px] object-contain'
          onError={() => {
            setFallida(ruta);
          }}
        />
      )}
    </div>
  );
}
